// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a859fd19","84":"3229ad39","247":"bacebbee","453":"20359781","627":"9a029c27","834":"b0e10363","867":"3aa15a21","923":"4f8d8937"}[chunkId] + ".chunk.js";
};